// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#ecasenkaDetail[data-v-8221cad4] .shop-thank-you .transfer-info p{font-size:17px;font-weight:600}", ""]);
// Exports
module.exports = exports;
